module.exports = __webpack_public_path__ + "static/media/mobile-app-promotion-de.275be7b9.png";